import {
  Box,
  Button,
  Switch,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { DiscountRow } from "./DiscountRow";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import "../credits/style.css";
import { foundSameTicketsAmount, sortByAmountTickets } from "../../../../helpers/creditsArray";
import { DiscountError, DiscountProps } from "../../../../types/generalSettings";


interface Props {
  discounts: Array<DiscountProps>;
  handleChangeDiscountsStatus: (competition: string) => void;
  isActiveDiscounts: boolean;
  handleSetDiscounts: (discountArr: Array<DiscountProps>, competition: string) => void;
  handleSaveDiscounts: () => void;
  competition: string,
  fillError: boolean
}

export const DiscountPickerComponent = ({
  discounts,
  handleChangeDiscountsStatus,
  isActiveDiscounts,
  handleSetDiscounts,
  handleSaveDiscounts,
  competition,
  fillError,
}: Props) => {
  const [errors, setErrors] = useState<Array<DiscountError>>([]);

  useEffect(() => {
    const countDuplicates = foundSameTicketsAmount(discounts);
    discounts.map((i, index) => {
      const errorExistIndex = errors.findIndex(
        (item) => item.discountId === i.id
      );
      if (errorExistIndex !== -1) {
        setErrors([
          ...errors.slice(0, errorExistIndex),
          (errors[errorExistIndex] = {
            ...errors[errorExistIndex],
            amountTickets: countDuplicates.find((duplicate) => duplicate === i.amountTickets) || i.amountTickets <= 0
              ? true
              : false,
            percent: i.percent < 0 || i.percent > 99 ? true : false
          }),
          ...errors.slice(errorExistIndex + 1),
        ]);
      }
      if (errorExistIndex === -1) {
        setErrors([
          ...errors,
          (errors[errors.length] = {
            discountId: i.id,
            amountTickets: i.amountTickets <= 0 ? true : false,
            percent: i.percent < 0 ? true : false,
          }),
        ]);
      }
    });
  }, [discounts]);
  const handleAddDiscount = (e) => {
    handleSetDiscounts([
      ...discounts,
      {
        amountTickets: discounts.length ? discounts[discounts.length - 1].amountTickets + 100 : 100,
        percent: 1,
        id: "_" + Math.random().toString(36).substr(2, 9),
      },
    ], competition);
  };
  const handleDeleteDiscount = (id: string | undefined) => () => {
    const index = discounts.findIndex((i) => i.id === id);
    const indexOfErrorRow = errors.findIndex((i) => i.discountId === id);
    handleSetDiscounts([...discounts.slice(0, index), ...discounts.slice(index + 1)], competition);
    setErrors([
      ...errors.slice(0, indexOfErrorRow),
      ...errors.slice(indexOfErrorRow + 1),
    ]);
  };

  const handleChangeDiscountProps = (id: string | undefined) => async (e: any) => {
    console.log("id ", id)
    const index = discounts.findIndex((i) => i.id === id);
    console.log("found index ", index)
    handleSetDiscounts([
      ...discounts.slice(0, index),
      { ...discounts[index], [e.currentTarget.name]: +e.currentTarget.value },
      ...discounts.slice(index + 1),
    ], competition);
  };

  const sortDiscountArrayOnBlur = () => {
    const creditsCopy = [...discounts];
    const sortedDiscounts = sortByAmountTickets(creditsCopy);
    handleSetDiscounts(sortedDiscounts, competition);
  };

  return (
    <Box className="creditsPickerWrapper">
      <Box>
        <Box display="flex" alignItems="center">
          <Typography variant="h6">Status</Typography>
          <Box marginLeft={1}>
            <Switch
              checked={isActiveDiscounts}
              onChange={() => handleChangeDiscountsStatus(competition)}
              color="primary"
              name="checkedB"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
          </Box>
        </Box>
      </Box>
      {<Box marginTop="2em" marginLeft="1em">
        {fillError && isActiveDiscounts && discounts.length === 0 && (
          <div className="common-error">At least one discount value must be filled</div>
        )}
      </Box>}
      {isActiveDiscounts && (
        <>
          <Box className="creditsWrapper">
            {discounts.map((i, index) => {
              const errorRow = errors.find((item) => item.discountId === i.id);
              return (
                <div key={i.id}>
                  <DiscountRow
                    key={i.id}
                    amountTickets={i.amountTickets}
                    percentForAddingDiscounts={i.percent}
                    handleDeleteDiscount={handleDeleteDiscount(i.id)}
                    handleChangeDiscountProps={handleChangeDiscountProps(i.id)}
                    countError={errorRow?.amountTickets}
                    percentError={errorRow?.percent}
                    sortDiscountArrayOnBlur={sortDiscountArrayOnBlur}
                  />
                  {index === discounts.length - 1 || discounts.length === 0 ? (
                    <AddCircleIcon
                      key={index}
                      onClick={handleAddDiscount}
                      className="add-discount"
                    />
                  ) : null}
                </div>
              );
            })}
            {discounts.length === 0 ? (
              <AddCircleIcon
                onClick={(event) => handleAddDiscount(event)}
                className="add-discount"
              />
            ) : null}
          </Box>
        </>
      )}

      <Box>
        <Button
          variant="contained"
          color={
            !errors.find((i) => i.amountTickets || i.percent) || !isActiveDiscounts ? "primary" : "default"
          }
          disableElevation
          disabled={!!errors.find((i) => i.amountTickets || i.percent) && isActiveDiscounts}
          onClick={handleSaveDiscounts}
        >
          Save
          </Button>
      </Box>
    </Box>
  );
};
